/*
 * src/components/TransferSuccess/EmailAddresses.jsx
 * Description: PAYAPP-967 refactor
 * Copyright (c) 2021 PredictiveUX
 */
import React from "react";

const EmailAddresses = ({ register, errors }) => {
  return (
    <div className="create-account__container-email">
      {[1, 2, 3, 4, 5].map((m) => {
        const marker = `email${m}`;
        return (
          <div className="create-account__email-input" key={m}>
            <input
              type="email"
              id={marker}
              name={marker}
              className="create-account__input form-control padding-bottom-10"
              placeholder="Add email address"
              ref={register({
                maxLength: 50,
                /* eslint-disable no-control-regex */
                pattern: /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/,
              })}
              autoComplete="no"
            />
            {errors[marker] && errors[marker].type === "maxLength" && (
              <span style={{ color: "#c30" }}>Max length exceeded</span>
            )}
            {errors[marker] && errors[marker].type === "pattern" && (
              <span style={{ color: "#c30" }}>Invalid email format</span>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default EmailAddresses;
